import {Injectable} from '@angular/core';
import {Session} from '@app/core/models/session.model';
import {SESSION_LIST} from '@app/core/resolvers/queries/session-list.query';

import {AppSyncHelper} from '@coach-bot/data-access/core';

import {ListSessionsQuery} from 'app/API.service';

import {ObjectMapper} from 'json-object-mapper';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SessionService {
  public constructor(private readonly _appSync: AppSyncHelper) {}

  public list(): Observable<Session[]> {
    return this._appSync
      .query(SESSION_LIST, null)
      .pipe(map((response: ListSessionsQuery) => ObjectMapper.deserializeArray(Session, response.listSessions)));
  }
}
